import React from "react";
import { toTitleCase } from "../../../../Utils/stringUtls";

const AdminWebsiteOverview = ({ data }) => {
  const { users } = data["7_0"];

  return (
    <div className="forms-instance review-summary-sub-heading">
      <div i2c-grid="grid gap-sm" className="">
        <div i2c-grid="12@md">
          <div className="fw-700 font-bold">Admin Website (C-Admin)</div>
          <div className="overview-help-text-for-heading">
            C-Admin allows you to manage self-service platform functionality.
            Program Managers can access the website to define card programs,
            services, and rules.
          </div>
        </div>
        <div i2c-grid="12@md">
          <div className="fw-700 font-bold">User Details</div>
          <div className="overview-help-text-for-heading">
            Please provide the email address, Name and Contact information of
            individuals who will require administrator access.
          </div>
        </div>
        {users.length
          ? users.map((user, index) => {
              const {
                iac_aw_cell,
                iac_aw_cell_country,
                iac_aw_email,
                iac_aw_fax,
                iac_aw_fax_country,
                iac_aw_name,
                iac_aw_phone,
                iac_aw_phone_country,
                iac_aw_title,
              } = user;
              return (
                <React.Fragment key={index}>
                  <div i2c-grid="12@md" className="fw-700 font-bold">
                    User {index + 1}
                  </div>
                  <div i2c-grid="6@md">
                    <div className="overview-help-text font-bold">Name</div>
                    <div className="overview-val-text">
                      {iac_aw_name?.length ? toTitleCase(iac_aw_name) : "-"}
                    </div>
                  </div>
                  <div i2c-grid="6@md">
                    <div className="overview-help-text font-bold">Title</div>
                    <div className="overview-val-text">
                      {iac_aw_title?.length ? toTitleCase(iac_aw_title) : "-"}
                    </div>{" "}
                  </div>

                  <div i2c-grid="6@md">
                    <div className="overview-help-text font-bold">
                      Phone Number
                    </div>
                    <div className="overview-val-text">
                      {iac_aw_phone?.length ? iac_aw_phone : "-"}
                    </div>{" "}
                  </div>
                  <div i2c-grid="6@md">
                    <div className="overview-help-text font-bold">
                      Cell Number
                    </div>
                    <div className="overview-val-text">
                      {iac_aw_cell?.length ? iac_aw_cell : "-"}
                    </div>{" "}
                  </div>
                  <div i2c-grid="6@md">
                    <div className="overview-help-text font-bold">Fax</div>
                    <div className="overview-val-text">
                      {iac_aw_fax?.length ? iac_aw_fax : "-"}
                    </div>{" "}
                  </div>
                  <div i2c-grid="6@md">
                    <div className="overview-help-text font-bold">Email</div>
                    <div className="overview-val-text">
                      {iac_aw_email?.length ? iac_aw_email : "-"}
                    </div>{" "}
                  </div>
                </React.Fragment>
              );
            })
          : ""}
      </div>
    </div>
  );
};
export default AdminWebsiteOverview;
